import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledIcon = styled.i(_templateObject(), function (props) {
  return "\n        & > svg { \n            margin-left: ".concat(props.padLeft ? '8px' : '0', ";\n            margin-right: ").concat(props.padRight ? '8px' : '0', ";\n        }\n    ");
});